module.exports = __webpack_public_path__ + "img/stagnation-icon.22d66d98.svg";